module.exports = __webpack_public_path__ + "img/fb.87e2e088.png";